import { RootState } from 'modules'
import { IExam } from '.'

export const selectExam = (state: RootState): IExam | null => state.exam
export const selectorIsUAExam = (state: RootState): boolean | false => state!.exam!.domain!.includes('skladu')
export const selectorIsCTExam = (state: RootState): boolean | false => (state!.exam!.domain!.includes('reshu.by') || state!.exam!.domain!.includes('ct.sdamgia.ru') || state!.exam!.domain!.includes('ce.sdamgia.ru'))
export const selectorIsKZExam = (state: RootState): boolean | false => (state!.exam!.domain!.includes('reshuent') || state!.exam!.domain!.includes('ent.sdamgia.ru'))
